export default __webpack_public_path__ + "locales/it/Ldap.json?hash=d471281d2fa9837f00f5c0676720f1e4";